import { render, staticRenderFns } from "./paipanResult.vue?vue&type=template&id=76a7b3fc&scoped=true"
import script from "./paipanResult.vue?vue&type=script&lang=js"
export * from "./paipanResult.vue?vue&type=script&lang=js"
import style0 from "./paipanResult.vue?vue&type=style&index=0&id=76a7b3fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a7b3fc",
  null
  
)

export default component.exports